import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { Platform } from "@ionic/angular";
import { BarcodeScanner } from "@capacitor-community/barcode-scanner";
import { SharedService } from "../../../../services/shared.service";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-barcode-manual-entry",
  templateUrl: "./manual-entry.component.html",
  styleUrls: ["./manual-entry.component.scss"],
})
export class BarcodeManualEntryComponent implements OnInit {

    barcode: string = null;

    constructor(
        private sharedService: SharedService,
        private platform: Platform,
        private modalController: ModalController
    ) {

    }

    ngOnInit(): void {
        return;
    }

    close(fromCloseIcon: boolean = false): void {
        // Ensure the scanner is properly closed
        if (this.platform.is("capacitor")) {
            document.body.classList.remove("scanner-active");
            BarcodeScanner.showBackground();
            BarcodeScanner.stopScan();
        }
        
        try {
            // Use the ID to ensure the correct modal is dismissed
            const modalId = 'stay-on-scanner';
            this.modalController.dismiss(fromCloseIcon ? null : this.barcode, null, modalId).then(() => {
                console.log('Modal dismissed successfully');
            }).catch(error => {
                console.error('Error dismissing modal:', error);
                // Fallback to general dismiss if ID-specific dismiss fails
                this.modalController.dismiss(fromCloseIcon ? null : this.barcode).catch(err => {
                    console.error('Fallback dismiss also failed:', err);
                });
            });
        } catch (error) {
            console.error('Exception during modal dismiss:', error);
        }
    }

}
